import qs from 'qs';
import { network } from 'services/network';

export const getUserDetails = (params) => {
    const querystring = qs.stringify({ username: params.email }, { addQueryPrefix: true, skipNulls: true });
    const url = `${'api/bo/getUserDetails'}${querystring}`;
    return network.get(url).then((response) => response.data);
};
